/**
 * Utilitaires pour décoder et vérifier les tokens JWT
 */

interface JWTPayload {
  sub: string;
  exp: number;
  impersonated_by?: number;
  impersonation_log_id?: number;
  original_admin_email?: string;
}

/**
 * Décode un token JWT (sans vérifier la signature)
 * Retourne null si le token est invalide
 */
export function decodeJWT(token: string): JWTPayload | null {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    
    const payload = parts[1];
    const decoded = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(decoded);
  } catch {
    return null;
  }
}

/**
 * Vérifie si un token JWT contient des claims d'impersonation
 */
export function isImpersonationToken(token: string | null): boolean {
  if (!token) return false;
  
  const payload = decodeJWT(token);
  if (!payload) return false;
  
  return !!(payload.impersonated_by && payload.impersonation_log_id);
}

/**
 * Extrait les informations d'impersonation d'un token JWT
 */
export function getImpersonationInfo(token: string | null): {
  impersonatedBy: number;
  impersonationLogId: number;
  originalAdminEmail: string;
} | null {
  if (!token) return null;
  
  const payload = decodeJWT(token);
  if (!payload || !payload.impersonated_by || !payload.impersonation_log_id) {
    return null;
  }
  
  return {
    impersonatedBy: payload.impersonated_by,
    impersonationLogId: payload.impersonation_log_id,
    originalAdminEmail: payload.original_admin_email || '',
  };
}
